import { CustomerAccountAddressDto } from "../coverage.model";
import { ProductType } from "@/api/constants/enums";
import { ColorStatusType } from "@/constants/colors.constants";
import { ChipStyle } from "../common.model";
import { UIACTION } from "@/constants/constants";

export interface CustomerProductDto {
	id: string;
	name: string;
	instanceName?: string;
	displayName: string;
	displayDescription?: string;
	bundle: boolean;
	enabled: boolean;
	isMainBundle: boolean;
	actions: ProductActionType[];
	state: CustomerProductStateType;
	completenessState: CustomerProductCompletenessStateType;
	activatedAt: string;
	terminatedAt?: string;
	contract?: CustomerProductCharacteristic;
	characteristics?: CustomerProductCharacteristic[];
	products?: CustomerProductDto[];
	type?: ProductType;
	serviceCharacteristicInstanceValue?: string;
	serviceCharacteristicName?: string;
	serviceCharacteristicValue?: string | CustomerAccountAddressDto;
}

export interface CustomerProductCharacteristic {
	id: string;
	name: string;
	displayName?: string;
	displayDescription?: string;
	bindingMonths?: number;
	bindingDays?: number;
	activatedAt: string;
	terminatedAt?: string;
	completedPercentage?: number;
	displayAmount?: number;
	includedAmount?: number;
	excludedAmount?: number;
}

export interface CustomerProductToGroup {
	id: string;
	name: string;
	displayName: string;
	processType: string;
}

export enum ProductActionType {
	CHANGE_OF_ADDRESS = "CHANGE_OF_ADDRESS",
	CONTINUE_CHANGE_OF_ADDRESS = "CONTINUE_CHANGE_OF_ADDRESS",
	CONFIG = "CONFIG",
	CANCEL_CHANGE_OF_ADDRESS = "CANCEL_CHANGE_OF_ADDRESS",
	STOP_CHANGE_OF_ADDRESS = "STOP_CHANGE_OF_ADDRESS",
	MODIFICATION = "CHANGE",
	SEE_DETAILS = "SEE_DETAILS",
	SEE_USAGE = "SEE_USAGE",
	SIM_CHANGE = "SIM_CHANGE",
	TRANSITION = "MIGRATE",
	TRANSITION_ONLY_MOBILES = "MIGRATE_ONLY_MOBILES",
	TRANSITION_SHARED_MOBILES = "MIGRATE_SHARED_MOBILES",
	TERMINATION = "TERMINATE",
	NEW_EXTRAS = "NEW_EXTRAS"
}

export const ProductActionTypePermissions: Record<ProductActionType, UIACTION> = {
	[ProductActionType.CHANGE_OF_ADDRESS]: UIACTION.CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_ACTION,
	[ProductActionType.CONTINUE_CHANGE_OF_ADDRESS]: UIACTION.CUSTOMER_PRODUCT_CONTINUE_CHANGE_OF_ADDRESS_ACTION,
	[ProductActionType.CONFIG]: UIACTION.CUSTOMER_PRODUCT_CONFIG_ACTION,
	[ProductActionType.CANCEL_CHANGE_OF_ADDRESS]: UIACTION.CUSTOMER_PRODUCT_CANCEL_CHANGE_OF_ADDRESS_ACTION,
	[ProductActionType.STOP_CHANGE_OF_ADDRESS]: UIACTION.CUSTOMER_PRODUCT_STOP_CHANGE_OF_ADDRESS_ACTION,
	[ProductActionType.MODIFICATION]: UIACTION.CUSTOMER_PRODUCT_MODIFICATION_ACTION,
	[ProductActionType.SEE_DETAILS]: UIACTION.CUSTOMER_PRODUCT_SEE_DETAILS_ACTION,
	[ProductActionType.SEE_USAGE]: UIACTION.CUSTOMER_PRODUCT_SEE_USAGE_ACTION,
	[ProductActionType.SIM_CHANGE]: UIACTION.CUSTOMER_PRODUCT_SIM_CHANGE_ACTION,
	[ProductActionType.TRANSITION]: UIACTION.CUSTOMER_PRODUCT_TRANSITION_ACTION,
	[ProductActionType.TRANSITION_ONLY_MOBILES]: UIACTION.CUSTOMER_PRODUCT_TRANSITION_ONLY_MOBILES_ACTION,
	[ProductActionType.TRANSITION_SHARED_MOBILES]: UIACTION.CUSTOMER_PRODUCT_TRANSITION_SHARED_MOBILES_ACTION,
	[ProductActionType.TERMINATION]: UIACTION.CUSTOMER_PRODUCT_TERMINATE_ACTION,
	[ProductActionType.NEW_EXTRAS]: "" as UIACTION
};

export enum CustomerProductStateType {
	PENDING_ACTIVATE = "PENDING_ACTIVATE",
	ACTIVE = "ACTIVE",
	TERMINATED = "TERMINATED",
	TRANSFERED = "TRANSFERED"
}

export enum CustomerProductCompletenessStateType {
	BROKEN = "BROKEN",
	COMPLETED = "COMPLETED",
	IN_PROGRESS = "IN_PROGRESS",
	UNKNOWN = "UNKNOWN"
}

export const ProductStateConfig: Record<CustomerProductStateType, ChipStyle> = {
	[CustomerProductStateType.PENDING_ACTIVATE]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.PURPLE
	},
	[CustomerProductStateType.ACTIVE]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.PURPLE
	},
	[CustomerProductStateType.TERMINATED]: {
		color: ColorStatusType.BLACK,
		background: ColorStatusType.WHITE
	},
	[CustomerProductStateType.TRANSFERED]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.BLACK
	}
};
